import React, { useState, useEffect, Fragment } from 'react';
// import { Deck, Slide } from 'spectacle';
import styled, { ThemeProvider } from 'styled-components';
import { Helmet } from 'react-helmet';
import theme from './theme';
import { mergeTheme, oneTheme } from './deckTheme';

import VocationStartLogoWhite from './imgs/vocation_start_logo_white2x.png';
import EdumetricsLogo from './imgs/edumetrics_logo.png';
// import AproximacionEstudiosImg from './imgs/aproximacion_estudios.jpg';
import AproximaEstudioModel from './imgs/aproximacion_estudio_model.png';
import HabilidadesIcons from './imgs/habilidades_icons.png';

import Icon02 from './imgs/icons/edu_iconos_6.svg';
import Icon03 from './imgs/icons/edu_iconos_3.svg';
import Icon05 from './imgs/icons/edu_iconos_5.svg';
import Icon07 from './imgs/icons/edu_iconos_7.svg';

import { ResetCSS, GlobalStyle, PageWrapper, PageNumber } from './styles';

// pages
import GradeDistributionChart from './GradeDistributionChart';
import ProgressPieChart from './ProgressPieChart';
import StackedDistribution from './StackedDistribution';

const Deck = props => {
  const style = {
    position: 'relative',
    height: `${props.theme.size.height}px`,
    width: `${props.theme.size.width}px`,
    backgroundColor: props.backgroundColor || '#FFFFFF',
    page: 'report' // css page definition
  };
  return <div style={style}>{props.children}</div>;
};

const Slide = props => {
  const style = {
    position: 'relative',
    height: `100%`,
    width: `100%`,
    backgroundColor: props.backgroundColor || 'transparent'
  };
  return (
    <div className='page' id='report' style={style}>
      {props.children}
    </div>
  );
};

export const ChartWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: ${({ height }) => (height ? height : 400)}px;
  width: 100%;
`;

// Slider Deck theme
const deckTheme = mergeTheme(oneTheme);

// const CREENCIAS_KEYS = [
//   'Muy Fijas',
//   'Fijas',
//   'Medio',
//   'Flexibles',
//   'Muy Flexibles'
// ];
const CREENCIAS_KEYS = [
  'No mejorables',
  ' ',
  'Algo mejorables',
  '  ',
  'Totalmente mejorables'
];

// https://github.com/FormidableLabs/spectacle/blob/master/docs/content/advanced-concepts.md#query-parameters
// add to url
// &exportMode=true
export const SlidePage = ({
  number,
  children,
  background,
  isFullCover,
  ...rest
}) => {
  // const isEven = number % 2 === 0;
  // console.log({ number, isEven });
  return (
    <PageWrapper {...rest} backgroundImage={background}>
      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: 45,
          left: 25
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon02}
          alt='edumetrics vocation start logo'
          style={{
            width: 200,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: 200,
          // top: 285,
          left: isFullCover ? 150 : 400
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon07}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 250 : 185,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          // bottom: 464,
          top: isFullCover ? 100 : 250,
          right: isFullCover ? 100 : 460
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon03}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 300 : 225,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: isFullCover ? 0 : -50,
          // top: 225,
          right: isFullCover ? 150 : 250
          // width: '100%'
          // display: 'flex',
          // justifyContent: 'center'
        }}
      >
        <img
          src={Icon05}
          alt='edumetrics vocation start logo'
          style={{
            width: isFullCover ? 275 : 225,
            height: '100%',
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </div>

      {children}
      {number && <PageNumber>{number}</PageNumber>}
    </PageWrapper>
  );
};

// caso real
// /c/9f01895a-1701-445d-bfe4-673b80a8932d/Ab7JsNgMspCwrJv-yYv5m
// /c/7f4fda3a-0394-4677-8be8-a1f72930b388/k1_QPEIBj4LxMnr99e5li?exportMode=true

// diego Prueba
// /c/cb1ca518-a2f4-4547-9c4e-73c1f107fb2d/nh_deGdmzMWSJj65fg1qx?exportMode=true
// /r/84af0b5d-5ced-44c5-acda-bd71ae233972?exportMode=true

const SlideHeader = ({ campaign }) => {
  const campaignLogo = campaign?.metadata?.logo ? campaign.metadata.logo : null;
  return (
    <div className='slide-header'>
      {campaignLogo && (
        <div className='logo'>
          <img
            src={campaignLogo}
            alt={`${campaign.organization || 'campaign'} logo`}
          />
        </div>
      )}
      <div className='logo'>
        <img src={EdumetricsLogo} alt='edumetrics logo' />
      </div>
      {/* <div className='logo'>
      <img src={ABLogo} alt='Albert Bridge logo' />
    </div> */}
    </div>
  );
};

const PlainHeader = () => (
  <div className='plain-header right'>
    <div className='logo-big'>
      <img src={VocationStartLogoWhite} alt='vocation-start logo' />
    </div>
  </div>
);

const VocationStartCollege = ({ campaign, responses }) => {
  const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(false);
  // const [user, setUser] = useState(null);
  const [campaignData, setCampaignData] = useState(null);
  // console.log({ props });
  // console.log({ campaign, responses });

  useEffect(() => {
    // console.log({ params });
    const parseCampaign = async () => {
      const male = responses.filter(resp => resp.data.SEX === 'Masculino');
      const female = responses.filter(resp => resp.data.SEX === 'Femenino');
      const grades = [...new Set(responses.map(resp => resp.data.grade))]
        .sort((a, b) => a.localeCompare(b))
        .filter(Boolean); // clean undefined and falsy grades (with no list)
      const gradeResponses = grades.map(grade => {
        return {
          grade,
          responses: responses.filter(resp => resp.data.grade === grade)
        };
      });
      // console.log({ gradeResponses });
      const infoData = { grades, male, female, gradeResponses };
      setCampaignData(infoData);
      setLoading(false);
    };
    parseCampaign();
  }, [campaign, responses]);

  // console.log({ user });
  if (loading) {
    return <div>loading...</div>;
  }
  // console.log({ campaignData });

  const gradesLength = campaignData?.grades.length;
  const hasGrades = gradesLength > 1;
  const firstStep = hasGrades ? 8 : 7;
  const secondStep = firstStep + gradesLength * 2;
  const thirdStep = secondStep + 4 + gradesLength * 2;
  const fourthStep = thirdStep + 3 + gradesLength;
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Helmet>
          <title>{`${(campaign.organization || campaign.title)
            .split(' ')
            .join('_')}_VocationStart_${campaign.id}`}</title>
        </Helmet>
        <ResetCSS />
        <GlobalStyle />
        <Deck theme={deckTheme} backgroundColor='#f0c045'>
          <Slide backgroundColor='#f0c045'>
            <SlidePage isFullCover>
              {campaign?.metadata?.logo && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={campaign.metadata.logo}
                    alt={`${campaign.organization || 'campaign'} logo`}
                    style={{
                      maxWidth: 250,
                      height: 100,
                      display: 'block',
                      objectFit: 'contain',
                      marginTop: 48
                    }}
                  />
                </div>
              )}
              <div className='title-page'>
                <div className='logo-big'>
                  <img src={VocationStartLogoWhite} alt='vocation-start logo' />
                </div>
              </div>
              <div
                className='top-body'
                style={{ paddingLeft: '5rem', paddingRight: '5rem' }}
              >
                <h1>Presentación de Resultados</h1>
                <h2>{campaign.organization || campaign.title}</h2>
              </div>
            </SlidePage>
          </Slide>

          {/** BLANK PAGE */}
          <Slide backgroundColor='#f0c045'>
            <SlidePage isFullCover></SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={1}>
              <SlideHeader campaign={campaign} />
              <div className='half-left'>
                <div>
                  <h1>
                    <span>¿</span>Qué es{' '}
                    <span>
                      <img
                        src={VocationStartLogoWhite}
                        style={{ marginLeft: '1rem' }}
                        alt='vocation-start logo'
                      />
                    </span>
                    <span>?</span>
                  </h1>
                </div>
              </div>
              <div className='slide-body right'>
                <div className='slide-content'>
                  <div className='flex-center'>
                    <div>
                      <p>
                        <strong>Vocation Start</strong> es un test enfocado en
                        el proceso de transición de educación básica a educación
                        media.
                        <br />
                        <br />
                        Diseñado para estudiantes de 8° básico y I° medio, busca
                        entregar información para que puedan identificar sus
                        principales fortalezas y aspectos a mejorar para
                        enfrentar esta etapa de transición académica.
                      </p>
                      <p>Vocation Start entrega información sobre:</p>
                      <div className='list-compact'>
                        <p>Aproximaciones al aprendizaje</p>
                        <ul>
                          <li>Motivaciones y estrategias de estudio</li>
                          <li>Teorías sobre el desarrollo de habilidades</li>
                        </ul>
                      </div>
                      <div className='list-compact'>
                        <p>Herramientas para la transición</p>
                        <ul>
                          <li>Incertidumbre ante la transición académica</li>
                          <li>Recursos para la transición escolar</li>
                        </ul>
                      </div>
                      <br />
                      <p className='text-sm'>
                        Nota: La definición de cada una de estas escalas se
                        encuentra disponible en documento adjunto entregado al
                        colegio.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={2}>
              <SlideHeader campaign={campaign} />
              <div className='half-left'>
                <div>
                  <h1>
                    <span>¿</span>Qué es{' '}
                    <span>
                      <img
                        src={VocationStartLogoWhite}
                        style={{ marginLeft: '1rem' }}
                        alt='vocation-start logo'
                      />
                    </span>
                    <span>?</span>
                  </h1>
                </div>
              </div>
              <div className='slide-body right'>
                <div className='slide-content'>
                  <h1>Objetivos</h1>
                  <div>
                    <ul>
                      <li>
                        Informar sobre las estrategias de estudio preferidas por
                        cada estudiante, así como sus creencias en relación al
                        aprendizaje, facilitando así la orientación para mejorar
                        las estrategias de aprendizaje y el rendimiento
                        académico en esta etapa.
                      </li>
                      <li>
                        Entregar información sobre las principales
                        preocupaciones de los y las estudiantes respecto de la
                        nueva etapa escolar, así como sobre sus recursos
                        positivos, para ayudar a los colegios a reducir la
                        ansiedad e incertidumbre que suele acompañar a sus
                        estudiantes en este proceso de transición.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            <Slide backgroundColor='#f0c045'>
              <SlidePage number={3}>
                <SlideHeader campaign={campaign} />
                <div className='third-left'>
                  <div>
                    <h1>Distribución de estudiantes participantes</h1>
                  </div>
                  <div className='footnote'>
                    <div>Número de participantes por curso</div>
                  </div>
                </div>
                <div className='slide-body big'>
                  <div className='slide-content'>
                    <h1>Distribución Detallada</h1>
                    <p style={{ fontSize: '1.5rem' }}>
                      <strong>Total</strong> = {responses.length} participantes.{' '}
                      {'('}
                      {campaignData?.gradeResponses.map((g, idx) => {
                        const isLast =
                          idx === campaignData.gradeResponses.length - 1;
                        return (
                          <Fragment key={`${g.grade}_${idx.toString()}_resp`}>
                            <strong>{g.grade}</strong>
                            {' = '}
                            <span>{g.responses.length}</span>
                            {isLast ? '' : '; '}
                          </Fragment>
                        );
                      })}
                      {')'}
                    </p>
                    <div>
                      <br />
                      <ChartWrapper height={600}>
                        <GradeDistributionChart
                          grades={campaignData?.gradeResponses}
                        />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </SlidePage>
            </Slide>
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={hasGrades ? 4 : 3}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Aproximaciones al Aprendizaje</h1>
                <h2>Motivaciones y Estrategias de Estudio</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={hasGrades ? 5 : 4}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Motivaciones y Estrategias de Estudio</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <p>
                      El Test Vocation Start describe el enfoque de estudio de
                      los y las estudiantes, identificando sus principales
                      motivaciones para estudiar y aprender, así como las
                      principales estrategias que utilizan en sus estudios.
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ height: 650 }}
                      src={AproximaEstudioModel}
                      alt='dsa'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={hasGrades ? 6 : 5}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Motivaciones y Estrategias de Estudio</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Porcentaje de estudiantes que tienen un puntaje ALTO y BAJO
                    en cada una de las Motivaciones para el Aprendizaje.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1 style={{ marginTop: 0 }}>
                    Motivación para el Aprendizaje
                  </h1>
                  <div className='scale-grid cols-2'>
                    <div className='scale-wrap'>
                      <h3>Motivación al aprendizaje profundo</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='MA' responses={responses} />
                      </ChartWrapper>
                    </div>
                    <div className='scale-wrap'>
                      <h3>Motivación al aprendizaje instrumental</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='MS' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                  <div className='scale-grid'>
                    <div className='scale-wrap'>
                      <h3>Motivación de logro académico</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='ML' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={hasGrades ? 7 : 6}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Motivaciones y Estrategias de Estudio</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Porcentaje de estudiantes que tienen un puntaje ALTO y BAJO
                    en cada una de las Estrategias de Estudio.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1 style={{ marginTop: 0 }}>Estrategias de Estudio</h1>
                  <div className='scale-grid cols-2'>
                    <div className='scale-wrap'>
                      <h3>Estrategias de aprendizaje profundo</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='AP' responses={responses} />
                      </ChartWrapper>
                    </div>
                    <div className='scale-wrap'>
                      <h3>Estrategias de aprendizaje instrumental</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='ES' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                  <div className='scale-grid'>
                    <div className='scale-wrap'>
                      <h3>Estrategias de logro académico</h3>
                      <ChartWrapper height={225}>
                        <ProgressPieChart scale='EL' responses={responses} />
                      </ChartWrapper>
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData?.grades
              .map(grade => [grade, grade])
              .flat()
              .map((grade, index) => {
                const gradeData = campaignData.gradeResponses.find(
                  g => g.grade === grade
                );
                const isEven = index % 2 === 0;
                return (
                  <Slide
                    backgroundColor='#f0c045'
                    key={`study${grade.grade}_${index}`}
                  >
                    <SlidePage number={firstStep + index}>
                      <SlideHeader campaign={campaign} />
                      <div className='third-left'>
                        <div>
                          <h1>Motivaciones y Estrategias de Estudio</h1>
                          <h2>{gradeData.grade}</h2>
                        </div>
                        <div className='footnote'>
                          <div>
                            Porcentaje de estudiantes {gradeData.grade} que
                            tienen un puntaje ALTO y BAJO en cada una de las{' '}
                            {isEven
                              ? 'Motivación para el Aprendizaje'
                              : 'Estrategias de Estudio'}
                          </div>
                        </div>
                      </div>
                      {isEven ? (
                        <div className='slide-body big'>
                          <div className='slide-content'>
                            <h1 style={{ margin: 0 }}>
                              Motivación para el Aprendizaje {gradeData.grade}
                            </h1>
                            <div className='scale-grid cols-2'>
                              <div className='scale-wrap'>
                                <h3>Motivación al aprendizaje profundo</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='MA'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                              <div className='scale-wrap'>
                                <h3>Motivación al aprendizaje instrumental</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='MS'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                            <div className='scale-grid'>
                              <div className='scale-wrap'>
                                <h3>Motivación de logro académico</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='ML'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className='slide-body big'>
                          <div className='slide-content'>
                            <h1 style={{ margin: 0 }}>
                              Estrategias de Estudio {gradeData.grade}
                            </h1>
                            <div className='scale-grid cols-2'>
                              <div className='scale-wrap'>
                                <h3>Estrategias de aprendizaje profundo</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='AP'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                              <div className='scale-wrap'>
                                <h3>Estrategias de aprendizaje instrumental</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='ES'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                            <div className='scale-grid'>
                              <div className='scale-wrap'>
                                <h3>Estrategias de logro académico</h3>
                                <ChartWrapper height={225}>
                                  <ProgressPieChart
                                    scale='EL'
                                    responses={gradeData.responses}
                                  />
                                </ChartWrapper>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </SlidePage>
                  </Slide>
                );
              })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={secondStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Aproximaciones al Aprendizaje</h1>
                <h2>Teorías sobre el Desarrollo de Habilidades</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={secondStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Teorías sobre el Desarrollo de Habilidades</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Teorías sobre el Desarrollo de Habilidades</h1>
                    <p>
                      La escala de Teorías Personales sobre el Desarrollo de
                      Habilidades explora las creencias de los y las estudiantes
                      sobre la posibilidad de modificar distintas habilidades
                      que despliegan en el ámbito escolar, como habilidades
                      numéricas, de comprensión lectora, para hacer deportes,
                      para aprender, etc.
                    </p>
                  </div>
                  <div className='image-wrapper'>
                    <img
                      style={{ height: 180, marginTop: 36 }}
                      src={HabilidadesIcons}
                      alt='dsa'
                    />
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={secondStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Teorías sobre el Desarrollo de Habilidades</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO muestran estudiantes que tienden a pensar
                    en las habilidades como algo fijo, no modificable;
                    resultados en VERDE muestran estudiantes cuyas creencias son
                    compatibles con la idea de que las habilidades sí pueden
                    desarrollarse.
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    Gráfico indica el número de alumnos participantes.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Creencias generales</h1>
                    <p>
                      El siguiente gráfico muestra la distribución de
                      estudiantes según el tipo de creencias que muestran en su
                      evaluación general de habilidades. Esto es, si en términos
                      generales consideran que sus habilidades pueden mejorar si
                      se esfuerzan, o son algo fijo que no pueden cambiar.
                    </p>

                    <ChartWrapper height={225}>
                      <StackedDistribution
                        scales={[
                          {
                            scale: 'HABILIDADES',
                            label: 'Creencias Generales'
                          }
                        ]}
                        responses={responses}
                        maxScale={6}
                        showLabels={false}
                        showLegend
                        colorPallete={'polar'}
                        rightMargin={245}
                        keys={CREENCIAS_KEYS}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={secondStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Teorías sobre el Desarrollo de Habilidades</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO muestran estudiantes que tienden a pensar
                    en las habilidades como algo fijo, no modificable;
                    resultados en VERDE muestran estudiantes cuyas creencias son
                    compatibles con la idea de que las habilidades sí pueden
                    desarrollarse.
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    Gráfico indica el número de alumnos participantes.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h1 style={{ margin: 0 }}>
                    Creencias sobre habilidades específicas
                  </h1>
                  <p
                    className='justified'
                    style={{ marginBottom: '24px', marginTop: '12px' }}
                  >
                    El siguiente gráfico muestra la distribución de los y las
                    estudiantes según el tipo de creencias que muestran en
                    relación a sus habilidades específicas.
                  </p>
                  <ChartWrapper height={550}>
                    <StackedDistribution
                      scales={[
                        {
                          scale: 'ABIND_01',
                          label: 'Habilidades Numéricas'
                        },
                        {
                          scale: 'ABIND_02',
                          label: 'Habilidades Verbales'
                        },
                        {
                          scale: 'ABIND_03',
                          label: 'Habilidades de Memoria'
                        },
                        {
                          scale: 'ABIND_04',
                          label: 'Habilidades Artísticas'
                        },
                        {
                          scale: 'ABIND_05',
                          label: 'Habilidades Deportivas'
                        },
                        {
                          scale: 'ABIND_06',
                          label: 'Habilidades de Aprendizaje'
                        }
                      ].reverse()}
                      responses={responses}
                      maxScale={5}
                      showLegend
                      colorPallete={'polar'}
                      rightMargin={245}
                      keys={CREENCIAS_KEYS}
                    />
                  </ChartWrapper>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData?.grades
              .map(grade => [grade, grade])
              .flat()
              .map((grade, index) => {
                const gradeData = campaignData.gradeResponses.find(
                  g => g.grade === grade
                );
                const isEven = index % 2 === 0;
                const pageNumber = secondStep + 4 + index;
                return (
                  <Slide
                    backgroundColor='#f0c045'
                    key={`hab__${grade.grade}_${index}`}
                  >
                    <SlidePage number={pageNumber}>
                      <SlideHeader campaign={campaign} />
                      <div className='third-left'>
                        <div>
                          <h1>Teorías sobre el Desarrollo de Habilidades</h1>
                          <h2>{gradeData.grade}</h2>
                        </div>
                        <div className='footnote'>
                          <div>
                            Resultados en ROJO muestran estudiantes que tienden
                            a pensar en las habilidades como algo fijo, no
                            modificable; resultados en VERDE muestran
                            estudiantes cuyas creencias son compatibles con la
                            idea de que las habilidades sí pueden desarrollarse.
                          </div>
                          <div style={{ marginTop: '1rem' }}>
                            Gráfico indica el número de alumnos participantes.
                          </div>
                        </div>
                      </div>
                      {isEven ? (
                        <div className='slide-body big'>
                          <div className='slide-content'>
                            <div>
                              <h1>Creencias generales {gradeData.grade}</h1>
                              <p>
                                El siguiente gráfico muestra la distribución de
                                estudiantes según el tipo de creencias que
                                muestran en su evaluación general de
                                habilidades. Esto es, si en términos generales
                                consideran que sus habilidades pueden mejorar si
                                se esfuerzan, o son algo fijo que no pueden
                                cambiar.
                              </p>
                              <ChartWrapper height={225}>
                                <StackedDistribution
                                  scales={[
                                    {
                                      scale: 'HABILIDADES',
                                      label: 'Creencias Generales'
                                    }
                                  ]}
                                  responses={gradeData.responses}
                                  maxScale={6}
                                  showLabels={false}
                                  showLegend
                                  // inverse
                                  colorPallete={'polar'}
                                  rightMargin={245}
                                  keys={CREENCIAS_KEYS}
                                />
                              </ChartWrapper>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className='slide-body big'>
                          <div className='slide-content'>
                            <h1 style={{ margin: 0 }}>
                              Creencias sobre habilidades específicas{' '}
                              {gradeData.grade}
                            </h1>
                            <p
                              className='justified'
                              style={{
                                marginBottom: '24px',
                                marginTop: '12px'
                              }}
                            >
                              El siguiente gráfico muestra la distribución de
                              los y las estudiantes según el tipo de creencias
                              que muestran en relación a sus habilidades
                              específicas.
                            </p>
                            <ChartWrapper height={600}>
                              <StackedDistribution
                                scales={[
                                  {
                                    scale: 'ABIND_01',
                                    label: 'Habilidades Numéricas'
                                  },
                                  {
                                    scale: 'ABIND_02',
                                    label: 'Habilidades Verbales'
                                  },
                                  {
                                    scale: 'ABIND_03',
                                    label: 'Habilidades de Memoria'
                                  },
                                  {
                                    scale: 'ABIND_04',
                                    label: 'Habilidades Artísticas'
                                  },
                                  {
                                    scale: 'ABIND_05',
                                    label: 'Habilidades Deportivas'
                                  },
                                  {
                                    scale: 'ABIND_06',
                                    label: 'Habilidades de Aprendizaje'
                                  }
                                ].reverse()}
                                responses={gradeData.responses}
                                maxScale={5}
                                showLegend
                                colorPallete={'polar'}
                                rightMargin={245}
                                keys={CREENCIAS_KEYS}
                              />
                            </ChartWrapper>
                          </div>
                        </div>
                      )}
                    </SlidePage>
                  </Slide>
                );
              })
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={thirdStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Herramientas para la Transición</h1>
                <h2>Incertidumbre ante la Transición Académica</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={thirdStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Incertidumbre ante la Transición Académica</h1>
                  <h2>Presentación</h2>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Incertidumbre ante la Transición Académica</h1>
                    <p>
                      Los siguientes resultados dan cuenta los sentimientos de
                      preocupación o ansiedad que pueden estar experimentando
                      los y las estudiantes en relación con los procesos de
                      cambio y adaptación que aparecen durante la transición de
                      la educación básica a la media.
                    </p>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={thirdStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Incertidumbre ante la Transición Académica</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en ROJO sugieren mayores niveles de preocupación
                    o incertidumbre en el área. Resultados en VERDE sugieren
                    bajos niveles o ausencia de incertidumbre ante la transición
                    en el área.
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    Gráfico indica el número de alumnos participantes.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1 style={{ margin: 0 }}>Resultados Generales</h1>
                    <h2>Contexto Académico</h2>
                    <p className='text-md'>
                      El siguiente gráfico presenta la distribución de los y las
                      estudiantes de acuerdo a su nivel de preocupación o
                      ansiedad frente a los posibles cambios de contexto,
                      asociados a la transición de educación básica a educación
                      media:
                    </p>
                    {/* <div className='scales-range' style={{ height: 175 }}>
                      <div className='range-single'>
                        <HorizontalRangeScale
                          scale='IATA_CON'
                          responses={responses}
                          maxScale={5}
                        />
                      </div>
                    </div> */}
                    <ChartWrapper height={165}>
                      <StackedDistribution
                        scales={[
                          {
                            scale: 'IATA_CON',
                            label: 'Contexto Académico'
                          }
                        ]}
                        responses={responses}
                        maxScale={5}
                        showLabels={false}
                        showLegend
                        inverse
                        colorPallete={'polar'}
                      />
                    </ChartWrapper>
                    <h2>Rendimiento y futuro</h2>
                    <p className='text-md'>
                      El siguiente gráfico presenta la distribución de los y las
                      estudiantes según su nivel de preocupación o ansiedad
                      frente a los nuevos desafíos académicos y la toma de
                      decisiones vocacionales, aspectos que adquieren mayor
                      relevancia en esta etapa:
                    </p>
                    {/* <div className='scales-range' style={{ height: 175 }}>
                      <div className='range-single'>
                        <HorizontalRangeScale
                          scale='IATA_REN'
                          responses={responses}
                          maxScale={5}
                        />
                      </div>
                    </div> */}
                    <ChartWrapper height={165}>
                      <StackedDistribution
                        scales={[
                          {
                            scale: 'IATA_REN',
                            label: 'Rendimiento y futuro'
                          }
                        ]}
                        responses={responses}
                        maxScale={5}
                        showLabels={false}
                        showLegend
                        inverse
                        colorPallete={'polar'}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {hasGrades ? (
            campaignData?.gradeResponses.map((grade, index) => (
              <Slide backgroundColor='#f0c045' key={`iata_${grade.grade}`}>
                <SlidePage number={thirdStep + 3 + index}>
                  <SlideHeader campaign={campaign} />
                  <div className='third-left'>
                    <div>
                      <h1>Incertidumbre ante la Transición Académica</h1>
                      <h2>{grade.grade}</h2>
                    </div>
                    <div className='footnote'>
                      <div>
                        Resultados en ROJO sugieren mayores niveles de
                        preocupación o incertidumbre en el área. Resultados en
                        VERDE sugieren bajos niveles o ausencia de incertidumbre
                        ante la transición en el área.
                      </div>
                      <div style={{ marginTop: '1rem' }}>
                        Gráfico indica el número de alumnos participantes.
                      </div>
                    </div>
                  </div>
                  <div className='slide-body big'>
                    <div className='slide-content'>
                      <div>
                        <h1 style={{ margin: 0 }}>Resultados {grade.grade}</h1>
                        <h2>Contexto Académico</h2>
                        <p className='text-md'>
                          El siguiente gráfico presenta la distribución de los y
                          las estudiantes de acuerdo a su nivel de preocupación
                          o ansiedad frente a los posibles cambios de contexto,
                          asociados a la transición de educación básica a
                          educación media:
                        </p>
                        {/* <div className='scales-range' style={{ height: 175 }}>
                          <div className='range-single'>
                            <HorizontalRangeScale
                              scale='IATA_CON'
                              responses={grade.responses}
                              maxScale={5}
                            />
                          </div>
                        </div> */}
                        <ChartWrapper height={165}>
                          <StackedDistribution
                            scales={[
                              {
                                scale: 'IATA_CON',
                                label: 'Contexto Académico'
                              }
                            ]}
                            responses={grade.responses}
                            maxScale={5}
                            showLabels={false}
                            showLegend
                            inverse
                            colorPallete={'polar'}
                          />
                        </ChartWrapper>
                        <h2>Rendimiento y futuro</h2>
                        <p className='text-md'>
                          El siguiente gráfico presenta la distribución de los y
                          las estudiantes según su nivel de preocupación o
                          ansiedad frente a los nuevos desafíos académicos y la
                          toma de decisiones vocacionales, aspectos que
                          adquieren mayor relevancia en esta etapa:
                        </p>
                        {/* <div className='scales-range' style={{ height: 175 }}>
                          <div className='range-single'>
                            <HorizontalRangeScale
                              scale='IATA_REN'
                              responses={grade.responses}
                              maxScale={5}
                            />
                          </div>
                        </div> */}
                        <ChartWrapper height={165}>
                          <StackedDistribution
                            scales={[
                              {
                                scale: 'IATA_REN',
                                label: 'Rendimiento y futuro'
                              }
                            ]}
                            responses={grade.responses}
                            maxScale={5}
                            showLabels={false}
                            showLegend
                            inverse
                            colorPallete={'polar'}
                          />
                        </ChartWrapper>
                      </div>
                    </div>
                  </div>
                </SlidePage>
              </Slide>
            ))
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={fourthStep}>
              <PlainHeader />
              <div className='plain-body right'>
                <h1>Herramientas para la Transición</h1>
                <h2>Recursos para la Transición Escolar</h2>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={fourthStep + 1}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1 style={{ marginTop: 0 }}>
                    Recursos para la Transición Escolar
                  </h1>
                  <h2>General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Resultados en VERDE muestran estudiantes que se perciben con
                    una alta presencia de recursos positivos para enfrentar la
                    transición escolar. Resultados en GRIS muestran estudiantes
                    que perciben una falta de o ausencia de recursos.
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    Gráfico indica el número de alumnos participantes.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h1>Recursos para la Transición Escolar</h1>
                    <p>
                      La escala de Recursos para la Transición Escolar se enfoca
                      en la identificación de recursos personales positivos con
                      los que cuentan los y las estudiantes, que les permitirían
                      afrontar de mejor forma los desafíos que implica la
                      transición a la enseñanza media, tanto en términos
                      académicos como vocacionales.
                    </p>
                    <p>
                      El siguiente gráfico presenta la distribución de los y las
                      estudiantes según su percepción sobre su disponibilidad
                      general de recursos positivos para enfrentar esta nueva
                      etapa:
                    </p>
                    {/* <div className='scales-range' style={{ height: 225 }}>
                      <div className='range-single'>
                        <div className='label'>Global</div>
                        <HorizontalRangeScale
                          scale='RECTR'
                          responses={responses}
                          maxScale={5}
                          greenScale
                          inverse
                        />
                      </div>
                    </div> */}
                    <ChartWrapper height={225}>
                      <StackedDistribution
                        scales={[
                          {
                            scale: 'RECTR',
                            label: 'Recursos'
                          }
                        ]}
                        responses={responses}
                        maxScale={5}
                        showLabels={false}
                        showLegend
                        // inverse
                        colorPallete={'greenScale'}
                      />
                    </ChartWrapper>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={fourthStep + 2}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1 style={{ marginTop: 0 }}>
                    Recursos para la Transición Escolar
                  </h1>
                  <h2>General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Los siguientes gráficos presentan por separado la percepción
                    de estudiantes en relación a diversos recursos psicológicos
                    positivos. Resultados en VERDE muestran estudiantes que se
                    perciben con una alta presencia de recursos positivos para
                    enfrentar la transición escolar. Resultados en GRIS muestran
                    estudiantes que perciben una falta de o ausencia de
                    recursos.
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    Gráfico indica el número de alumnos participantes.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h2 style={{ margin: 0 }}>Autoeficacia</h2>
                    <p className='text-md'>
                      Se relaciona con la percepción de confianza en las propias
                      capacidades para asumir y poner el esfuerzo necesario para
                      tener éxito al enfrentar los cambios y desafíos propios de
                      la transición:
                    </p>
                  </div>
                  {/* <div className='scales-range' style={{ height: 175 }}>
                    <div className='range-single'>
                      <HorizontalRangeScale
                        scale='RECTR_AUT'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                  </div> */}
                  <ChartWrapper
                    height={165}
                    style={{ marginTop: '1.5rem', marginBottom: '2rem' }}
                  >
                    <StackedDistribution
                      scales={[
                        {
                          scale: 'RECTR_AUT',
                          label: 'Autoeficacia'
                        }
                      ]}
                      responses={responses}
                      maxScale={5}
                      showLabels={false}
                      showLegend
                      colorPallete={'greenScale'}
                    />
                  </ChartWrapper>
                  <div>
                    <h2>Optimismo</h2>
                    <p className='text-md'>
                      Capacidad para mantener una perspectiva positiva en
                      relación a los desafíos que se enfrentarán en los próximos
                      años, confiando en que las experiencias positivas primaran
                      sobre las negativas:
                    </p>
                  </div>
                  {/* <div className='scales-range' style={{ height: 175 }}>
                    <div className='range-single'>
                      <HorizontalRangeScale
                        scale='RECTR_OPT'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                  </div> */}
                  <ChartWrapper
                    height={165}
                    style={{ marginTop: '1.5rem', marginBottom: '2rem' }}
                  >
                    <StackedDistribution
                      scales={[
                        {
                          scale: 'RECTR_OPT',
                          label: 'Optimismo'
                        }
                      ]}
                      responses={responses}
                      maxScale={5}
                      showLabels={false}
                      showLegend
                      colorPallete={'greenScale'}
                    />
                  </ChartWrapper>
                </div>
              </div>
            </SlidePage>
          </Slide>

          <Slide backgroundColor='#f0c045'>
            <SlidePage number={fourthStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1 style={{ marginTop: 0 }}>
                    Recursos para la Transición Escolar
                  </h1>
                  <h2>General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Los siguientes gráficos presentan por separado la percepción
                    de estudiantes en relación a diversos recursos psicológicos
                    positivos. Resultados en VERDE muestran estudiantes que se
                    perciben con una alta presencia de recursos positivos para
                    enfrentar la transición escolar. Resultados en GRIS muestran
                    estudiantes que perciben una falta de o ausencia de
                    recursos.
                  </div>
                  <div style={{ marginTop: '1rem' }}>
                    Gráfico indica el número de alumnos participantes.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <div>
                    <h2 style={{ margin: 0 }}>Esperanza</h2>
                    <p className='text-md'>
                      Creencias positivas sobre la propia capacidad para
                      alcanzar las metas propuestas para el nuevo ciclo escolar,
                      así como para redirigir las estrategias para el logro de
                      las mismas cuando es necesario:
                    </p>
                  </div>
                  {/* <div className='scales-range' style={{ height: 175 }}>
                    <div className='range-single'>
                      <HorizontalRangeScale
                        scale='RECTR_ESP'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                  </div> */}
                  <ChartWrapper
                    height={165}
                    style={{ marginTop: '1.5rem', marginBottom: '2rem' }}
                  >
                    <StackedDistribution
                      scales={[
                        {
                          scale: 'RECTR_ESP',
                          label: 'Esperanza'
                        }
                      ]}
                      responses={responses}
                      maxScale={5}
                      showLabels={false}
                      showLegend
                      colorPallete={'greenScale'}
                    />
                  </ChartWrapper>
                  <div>
                    <h2>Resiliencia</h2>
                    <p className='text-md'>
                      Capacidad de los los y las estudiantes para enfrentar de
                      forma exitosa los diversos contratiempos, reveses y
                      desafíos que son propios del curso normal de la vida
                      escolar, tales como sacarse una mala nota o recibir
                      comentarios negativos en un trabajo:
                    </p>
                  </div>
                  {/* <div className='scales-range' style={{ height: 175 }}>
                    <div className='range-single'>
                      <HorizontalRangeScale
                        scale='RECTR_RES'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                  </div> */}
                  <ChartWrapper
                    height={165}
                    style={{ marginTop: '1.5rem', marginBottom: '2rem' }}
                  >
                    <StackedDistribution
                      scales={[
                        {
                          scale: 'RECTR_RES',
                          label: 'Resiliencia'
                        }
                      ]}
                      responses={responses}
                      maxScale={5}
                      showLabels={false}
                      showLegend
                      colorPallete={'greenScale'}
                    />
                  </ChartWrapper>
                </div>
              </div>
            </SlidePage>
          </Slide>

          {/* <Slide backgroundColor='#f0c045'>
            <SlidePage number={fourthStep + 3}>
              <SlideHeader campaign={campaign} />
              <div className='third-left'>
                <div>
                  <h1>Recursos para la Transición Escolar</h1>
                  <h2>Distribución General</h2>
                </div>
                <div className='footnote'>
                  <div>
                    Los siguientes resultados representan el puntaje global y
                    por separado para esta escala. Resultados en VERDE sugieren
                    alta presencia de recursos para enfrentar la transición
                    escolar. Resultados en GRIS sugieren la falta o ausencia de
                    recursos, por lo que es importante trabajar para el
                    desarrollo de esas capacidades.
                  </div>
                </div>
              </div>
              <div className='slide-body big'>
                <div className='slide-content'>
                  <h2>Resultados generales</h2>
                  <p>
                    A continuación se presentan los puntajes obtenidos a nivel
                    global y en las distintas subescalas, para identifcar las
                    principales fortalezas y aspectos que puedes mejorar.
                  </p>
                  <div className='scales-range' style={{ height: 225 }}>
                    <div className='range-single'>
                      <div className='label'>Global</div>
                      <HorizontalRangeScale
                        scale='RECTR'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                  </div>
                  <div
                    className='scales-range'
                    style={{ height: 300, marginTop: 50 }}
                  >
                    <div className='range-row'>
                      <div className='label'>Autoeficacia</div>
                      <HorizontalRangeScale
                        scale='RECTR_AUT'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Optimismo</div>
                      <HorizontalRangeScale
                        scale='RECTR_OPT'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Esperanza</div>
                      <HorizontalRangeScale
                        scale='RECTR_ESP'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                    <div className='range-row'>
                      <div className='label'>Resiliencia</div>
                      <HorizontalRangeScale
                        scale='RECTR_RES'
                        responses={responses}
                        maxScale={5}
                        greenScale
                        inverse
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SlidePage>
          </Slide> */}

          {hasGrades ? (
            campaignData?.gradeResponses.map((grade, index) => (
              <Slide backgroundColor='#f0c045' key={`recursos_${grade.grade}`}>
                <SlidePage number={fourthStep + 4 + index}>
                  <SlideHeader campaign={campaign} />
                  <div className='third-left'>
                    <div>
                      <h1 style={{ marginTop: 0 }}>
                        Recursos para la Transición Escolar
                      </h1>
                      <h2>{grade.grade}</h2>
                    </div>
                    <div className='footnote'>
                      <div>
                        Los siguientes resultados representan el puntaje global
                        y por separado para esta escala. Resultados en VERDE
                        muestran estudiantes que se perciben con una alta
                        presencia de recursos positivos para enfrentar la
                        transición escolar. Resultados en GRIS muestran
                        estudiantes que perciben una falta de o ausencia de
                        recursos.
                      </div>
                      <div style={{ marginTop: '1rem' }}>
                        Gráfico indica el número de alumnos participantes.
                      </div>
                    </div>
                  </div>
                  <div className='slide-body big'>
                    <div className='slide-content'>
                      <h2 style={{ margin: 0 }}>Resultados {grade.grade}</h2>
                      <p>
                        A continuación se presentan los puntajes obtenidos a
                        nivel global y en las distintas subescalas:
                      </p>
                      {/* <div className='scales-range' style={{ height: 225 }}>
                        <div className='range-single'>
                          <div className='label'>Global</div>
                          <HorizontalRangeScale
                            scale='RECTR'
                            responses={grade.responses}
                            maxScale={5}
                            greenScale
                            inverse
                          />
                        </div>
                      </div> */}
                      <ChartWrapper height={225}>
                        <StackedDistribution
                          scales={[
                            {
                              scale: 'RECTR',
                              label: 'Recursos'
                            }
                          ]}
                          responses={grade.responses}
                          maxScale={5}
                          showLabels={false}
                          showLegend
                          // inverse
                          colorPallete={'greenScale'}
                        />
                      </ChartWrapper>
                      {/* <div
                        className='scales-range'
                        style={{ height: 250, marginTop: 50 }}
                      >
                        <div className='range-row'>
                          <div className='label'>Autoeficacia</div>
                          <HorizontalRangeScale
                            scale='RECTR_AUT'
                            responses={grade.responses}
                            maxScale={5}
                            greenScale
                            inverse
                          />
                        </div>
                        <div className='range-row'>
                          <div className='label'>Optimismo</div>
                          <HorizontalRangeScale
                            scale='RECTR_OPT'
                            responses={grade.responses}
                            maxScale={5}
                            greenScale
                            inverse
                          />
                        </div>
                        <div className='range-row'>
                          <div className='label'>Esperanza</div>
                          <HorizontalRangeScale
                            scale='RECTR_ESP'
                            responses={grade.responses}
                            maxScale={5}
                            greenScale
                            inverse
                          />
                        </div>
                        <div className='range-row'>
                          <div className='label'>Resiliencia</div>
                          <HorizontalRangeScale
                            scale='RECTR_RES'
                            responses={grade.responses}
                            maxScale={5}
                            greenScale
                            inverse
                          />
                        </div>
                      </div> */}
                      <ChartWrapper height={350} style={{ marginTop: '3rem' }}>
                        <StackedDistribution
                          scales={[
                            {
                              scale: 'RECTR_AUT',
                              label: 'Autoeficacia'
                            },
                            {
                              scale: 'RECTR_OPT',
                              label: 'Optimismo'
                            },
                            {
                              scale: 'RECTR_ESP',
                              label: 'Esperanza'
                            },
                            {
                              scale: 'RECTR_RES',
                              label: 'Resiliencia'
                            }
                          ].reverse()}
                          responses={grade.responses}
                          maxScale={5}
                          leftMargin={125}
                          // showLabels={false}
                          showLegend={false}
                          colorPallete={'greenScale'}
                        />
                      </ChartWrapper>
                    </div>
                  </div>
                </SlidePage>
              </Slide>
            ))
          ) : (
            <div></div>
          )}

          <Slide backgroundColor='#f0c045'>
            <SlidePage isFullCover>
              <div className='title-page'>
                <div className='logo-big'>
                  <img
                    style={{ marginTop: 150 }}
                    src={VocationStartLogoWhite}
                    alt='vocation-start logo'
                  />
                </div>
              </div>
            </SlidePage>
          </Slide>
        </Deck>
      </Fragment>
    </ThemeProvider>
  );
};

export default VocationStartCollege;
